export default __webpack_public_path__ + "static/media/preview.0c3be829.png";